import { render } from "./FileProperties.vue?vue&type=template&id=04d2fd60&scoped=true"
import script from "./FileProperties.vue?vue&type=script&lang=js"
export * from "./FileProperties.vue?vue&type=script&lang=js"

import "./FileProperties.vue?vue&type=style&index=0&id=04d2fd60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d2fd60"]])

export default __exports__